// extracted by mini-css-extract-plugin
export default {"root":"HPjaOq","checkbox":"B0_Bos","checkboxError":"Z6Kw5I"};